export const TITLE = "activation.second_land_extension_modal.title";
export const DESCRIPTION = "activation.second_land_extension_modal.description";
export const CTA = "activation.second_land_extension_modal.cta";
